import { Injectable } from '@angular/core';
import { Settings, Zone } from 'luxon';
import { AppContext } from '../../common/public-api';
import { StringUtils } from '../../common/utils/string.util';
import { TimezoneInfo } from '../models/timezone-info';
declare global {
  var sigv: { appContext: AppContext };
}
/**
 * Environment Service
 *
 * @export
 * @class AppEnvService
 */
@Injectable()
export class AppEnvService {
  public static readonly staticEnvConfig: any = () => {
    try {
      return globalThis.sigv.appContext.envConfig;
    } catch (error) {
      return {};
    }
  };
  /**
   * App timezone information.
   */
  timezoneInfo?: TimezoneInfo;

  constructor(private _appContext: AppContext) {
    this._initTimezone();
  }

  /**
   * Setup timezone information.
   *
   * @private
   * @memberof AppEnvService
   */
  private _initTimezone(): void {
    if (StringUtils.isEmpty(this._appContext.envConfig?.timezone) === false) {
      Settings.defaultZone = this._appContext.envConfig?.timezone ?? 'system';
    }

    const zone = Settings.defaultZone as Zone;
    const nowTime = Date.now();
    this.timezoneInfo = {
      zoneName: zone.name,
      offsetName: zone.formatOffset(nowTime, 'techie'),
      offset: zone.offset(nowTime),
    };
  }
}
